module.exports={
    "uplift_dispenseAd": {
      "id": "uplift_dispenseAd",
      "eventName": "vex_inicio_gatilho_g_dispensar",
      "eventProduct": "uplift",
      "eventCategory": "vexpenses",
      "eventAction": "Clique em dispensar anúncio",
      "eventValue": 0
    },
    "uplift_learnMoreAd": {
      "id": "uplift_learnMoreAd",
      "eventName": "vex_inicio_gatilho_g_saibamais",
      "eventProduct": "uplift",
      "eventCategory": "vexpenses",
      "eventAction": "Clique em saiba mais no anúncio",
      "eventValue": 0
    }
}
